import React from 'react';
import { useSelector } from 'react-redux';

import ListItem from './listItem';

export default function List() {
  const dataOrig = useSelector((state) => state.data.dataOrig);
  /* 
  const achievedList = dataOrig.filter((obj) => {
    return obj.STATUS === 'Achieved (self-declared)';
  });
  
  const achievedListSort = achievedList.sort((a, b) => {
    return a.NAME.localeCompare(b.NAME);
  }); */

  const lawList = dataOrig.filter((obj) => {
    return obj.STATUS === 'In law';
  });

  const lawlistSort = lawList.sort((a, b) => {
    return a.NAME.localeCompare(b.NAME);
  });

  const lawListSortAlpa = lawlistSort.sort((a, b) => {
    return a.YEAR - b.YEAR;
  });

  const proposedList = dataOrig.filter((obj) => {
    return obj.STATUS === 'In policy document';
  });

  const proposedListSort = proposedList.sort((a, b) => {
    return a.NAME.localeCompare(b.NAME);
  });

  const proposedListSortAlpa = proposedListSort.sort((a, b) => {
    return a.YEAR - b.YEAR;
  });

  const policyList = dataOrig.filter((obj) => {
    return obj.STATUS === 'Declaration / pledge';
  });

  const policyListSort = policyList.sort((a, b) => {
    return a.NAME.localeCompare(b.NAME);
  });

  const policyListSortAlpa = policyListSort.sort((a, b) => {
    return a.YEAR - b.YEAR;
  });

  const talkingList = dataOrig.filter((obj) => {
    return obj.STATUS === 'Proposed / in discussion';
  });

  const talkingListSort = talkingList.sort((a, b) => {
    return a.NAME.localeCompare(b.NAME);
  });

  const talkingListSortAlpa = talkingListSort.sort((a, b) => {
    return a.YEAR - b.YEAR;
  });

  return (
    <section className="col-wrap">
      {/* 
      <h3>Achieved (self-declared)</h3>
      {achievedListSort.map((obj) => {
        return <ListItem {...obj} key={obj.CODE} />;
      })} */}
      <h3>In law</h3>
      {lawListSortAlpa.map((obj) => {
        return <ListItem {...obj} key={obj.CODE} />;
      })}
      <h3>In policy document</h3>
      {proposedListSortAlpa.map((obj) => {
        return <ListItem {...obj} key={obj.CODE} />;
      })}
      <h3>Declaration / pledge</h3>
      {policyListSortAlpa.map((obj) => {
        return <ListItem {...obj} key={obj.CODE} />;
      })}
      <h3>Proposed / in discussion</h3>
      {talkingListSortAlpa.map((obj) => {
        return <ListItem {...obj} key={obj.CODE} />;
      })}
    </section>
  );
}
